module.exports = __webpack_public_path__ + "img/a.b6c28c7f.png";